function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
var _ref2 = /*#__PURE__*/React.createElement("title", null, "utu_dark");
var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Login-choose",
  transform: "translate(-182.000000, -907.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "utu_dark",
  transform: "translate(182.083333, 907.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M41.0106136,68.6925114 L69.7265227,68.6925114 L69.7265227,40.1356932 L41.0106136,40.1356932 L41.0106136,68.6925114 Z M65.9878864,65.0334205 L44.5901591,65.0334205 L44.5901591,43.7152386 L65.9878864,43.7152386 L65.9878864,65.0334205 Z",
  id: "Fill-1",
  fill: "#98D6D8"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-2",
  fill: "#98D6D8",
  points: "49.99925 47.3743295 49.99925 50.953875 53.5787955 50.953875 53.5787955 61.6129659 57.1583409 61.6129659 57.1583409 50.953875 60.7378864 50.953875 60.7378864 47.3743295"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0.521977273,68.7720568 L29.2378864,68.7720568 L29.2378864,40.2152386 L0.521977273,40.2152386 L0.521977273,68.7720568 Z M25.49925,65.1129659 L4.10152273,65.1129659 L4.10152273,43.7947841 L25.49925,43.7947841 L25.49925,65.1129659 Z",
  id: "Fill-3",
  fill: "#98D6D8"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16.5901591,47.3743295 L16.5901591,56.2834205 C16.5901591,57.2379659 15.7947045,58.0334205 14.8401591,58.0334205 C13.8856136,58.0334205 13.0901591,57.2379659 13.0901591,56.2834205 L13.0901591,47.3743295 L9.51061364,47.3743295 L9.51061364,56.2834205 C9.51061364,59.2266023 11.8969773,61.6129659 14.8401591,61.6129659 C17.7833409,61.6129659 20.1697045,59.2266023 20.1697045,56.2834205 L20.1697045,47.3743295 L16.5901591,47.3743295 Z",
  id: "Fill-4",
  fill: "#98D6D8"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-5",
  fill: "#98D6D8",
  points: "29.2378864 56.2834205 41.0106136 56.2834205 41.0106136 52.703875 29.2378864 52.703875"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-6",
  fill: "#98D6D8",
  points: "69.7265227 56.2834205 81.4197045 56.2834205 81.4197045 52.703875 69.7265227 52.703875"
}), /*#__PURE__*/React.createElement("path", {
  d: "M81.4195455,28.8402386 L110.135455,28.8402386 L110.135455,0.283420455 L81.4195455,0.283420455 L81.4195455,28.8402386 Z M106.317273,25.1811477 L84.9195455,25.1811477 L84.9195455,3.86296591 L106.317273,3.86296591 L106.317273,25.1811477 Z",
  id: "Fill-7",
  fill: "#98D6D8"
}), /*#__PURE__*/React.createElement("path", {
  d: "M97.4081818,7.44251136 L97.4081818,16.3516023 C97.4081818,17.3061477 96.6127273,18.1016023 95.6581818,18.1016023 C94.7036364,18.1016023 93.9081818,17.3061477 93.9081818,16.3516023 L93.9081818,7.44251136 L90.3286364,7.44251136 L90.3286364,16.3516023 C90.3286364,19.2947841 92.715,21.6811477 95.6581818,21.6811477 C98.6013636,21.6811477 100.987727,19.2947841 100.987727,16.3516023 L100.987727,7.44251136 L97.4081818,7.44251136 Z",
  id: "Fill-8",
  fill: "#98D6D8"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-9",
  fill: "#98D6D8",
  points: "69.3287955 16.3516023 81.3401591 16.3516023 81.3401591 12.7720568 69.3287955 12.7720568"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-10",
  fill: "#231F20",
  points: "28.9197045 16.3516023 40.6924318 16.3516023 40.6924318 12.7720568 28.9197045 12.7720568"
}), /*#__PURE__*/React.createElement("path", {
  d: "M40.6924318,28.7606932 L69.4083409,28.7606932 L69.4083409,0.203875 L40.6924318,0.203875 L40.6924318,28.7606932 Z M65.6697045,25.1016023 L44.2719773,25.1016023 L44.2719773,3.78342045 L65.6697045,3.78342045 L65.6697045,25.1016023 Z",
  id: "Fill-11",
  fill: "#231F20"
}), /*#__PURE__*/React.createElement("path", {
  d: "M40.6924318,28.7606932 L69.4083409,28.7606932 L69.4083409,0.203875 L40.6924318,0.203875 L40.6924318,28.7606932 Z M65.6697045,25.1016023 L44.2719773,25.1016023 L44.2719773,3.78342045 L65.6697045,3.78342045 L65.6697045,25.1016023 Z",
  id: "Stroke-12",
  stroke: "#231F20",
  strokeWidth: 0.25
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-13",
  fill: "#231F20",
  points: "49.6015227 7.44251136 49.6015227 11.0220568 53.1810682 11.0220568 53.1810682 21.6811477 56.7606136 21.6811477 56.7606136 11.0220568 60.4197045 11.0220568 60.4197045 7.44251136"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Stroke-14",
  stroke: "#231F20",
  strokeWidth: 0.25,
  points: "49.6015227 7.44251136 49.6015227 11.0220568 53.1810682 11.0220568 53.1810682 21.6811477 56.7606136 21.6811477 56.7606136 11.0220568 60.4197045 11.0220568 60.4197045 7.44251136"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0.203795455,28.8402386 L28.9197045,28.8402386 L28.9197045,0.283420455 L0.203795455,0.283420455 L0.203795455,28.8402386 Z M25.1810682,25.1811477 L3.78334091,25.1811477 L3.78334091,3.86296591 L25.1810682,3.86296591 L25.1810682,25.1811477 Z",
  id: "Fill-15",
  fill: "#231F20"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0.203795455,28.8402386 L28.9197045,28.8402386 L28.9197045,0.283420455 L0.203795455,0.283420455 L0.203795455,28.8402386 Z M25.1810682,25.1811477 L3.78334091,25.1811477 L3.78334091,3.86296591 L25.1810682,3.86296591 L25.1810682,25.1811477 Z",
  id: "Stroke-16",
  stroke: "#231F20",
  strokeWidth: 0.25
}), /*#__PURE__*/React.createElement("path", {
  d: "M16.2719773,7.44251136 L16.2719773,16.3516023 C16.2719773,17.3061477 15.4765227,18.1016023 14.5219773,18.1016023 C13.5674318,18.1016023 12.7719773,17.3061477 12.7719773,16.3516023 L12.7719773,7.44251136 L9.19243182,7.44251136 L9.19243182,16.3516023 C9.19243182,19.2947841 11.5787955,21.6811477 14.5219773,21.6811477 C17.4651591,21.6811477 19.8515227,19.2947841 19.8515227,16.3516023 L19.8515227,7.44251136 L16.2719773,7.44251136 Z",
  id: "Fill-17",
  fill: "#231F20"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16.2719773,7.44251136 L16.2719773,16.3516023 C16.2719773,17.3061477 15.4765227,18.1016023 14.5219773,18.1016023 C13.5674318,18.1016023 12.7719773,17.3061477 12.7719773,16.3516023 L12.7719773,7.44251136 L9.19243182,7.44251136 L9.19243182,16.3516023 C9.19243182,19.2947841 11.5787955,21.6811477 14.5219773,21.6811477 C17.4651591,21.6811477 19.8515227,19.2947841 19.8515227,16.3516023 L19.8515227,7.44251136 L16.2719773,7.44251136 Z",
  id: "Stroke-18",
  stroke: "#231F20",
  strokeWidth: 0.25
}), /*#__PURE__*/React.createElement("path", {
  d: "M80.9422727,69.2493295 L109.658182,69.2493295 L109.658182,40.6925114 L80.9422727,40.6925114 L80.9422727,69.2493295 Z M105.919545,65.5106932 L84.5218182,65.5106932 L84.5218182,44.1925114 L105.919545,44.1925114 L105.919545,65.5106932 Z",
  id: "Fill-19",
  fill: "#231F20"
}), /*#__PURE__*/React.createElement("path", {
  d: "M80.9422727,69.2493295 L109.658182,69.2493295 L109.658182,40.6925114 L80.9422727,40.6925114 L80.9422727,69.2493295 Z M105.919545,65.5106932 L84.5218182,65.5106932 L84.5218182,44.1925114 L105.919545,44.1925114 L105.919545,65.5106932 Z",
  id: "Stroke-20",
  stroke: "#231F20",
  strokeWidth: 0.25
}), /*#__PURE__*/React.createElement("path", {
  d: "M97.0104545,47.7720568 L97.0104545,56.6811477 C97.0104545,57.6356932 96.215,58.4311477 95.2604545,58.4311477 C94.3059091,58.4311477 93.5104545,57.6356932 93.5104545,56.6811477 L93.5104545,47.7720568 L89.9309091,47.7720568 L89.9309091,56.6811477 C89.9309091,59.6243295 92.3172727,62.0106932 95.2604545,62.0106932 C98.2036364,62.0106932 100.59,59.6243295 100.59,56.6811477 L100.59,47.7720568 L97.0104545,47.7720568 Z",
  id: "Fill-21",
  fill: "#231F20"
}), /*#__PURE__*/React.createElement("path", {
  d: "M97.0104545,47.7720568 L97.0104545,56.6811477 C97.0104545,57.6356932 96.215,58.4311477 95.2604545,58.4311477 C94.3059091,58.4311477 93.5104545,57.6356932 93.5104545,56.6811477 L93.5104545,47.7720568 L89.9309091,47.7720568 L89.9309091,56.6811477 C89.9309091,59.6243295 92.3172727,62.0106932 95.2604545,62.0106932 C98.2036364,62.0106932 100.59,59.6243295 100.59,56.6811477 L100.59,47.7720568 L97.0104545,47.7720568 Z",
  id: "Stroke-22",
  stroke: "#231F20",
  strokeWidth: 0.25
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-23",
  fill: "#231F20",
  points: "85.0165909 42.1245682 67.1301591 24.2382159 64.5991023 26.7692727 82.4854545 44.6557045"
}))));
const SvgUtuDark = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, ["svgRef", "title"]);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "112px",
    height: "70px",
    viewBox: "0 0 112 70",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3);
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgUtuDark, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/utu_dark.6e019ae4.svg";
export { ForwardRef as ReactComponent };